import React from 'react';
import { Card, Dropdown, Table } from '@themesberg/react-bootstrap';
import { eventSingleShowReducerTypes, storeTypes } from 'types';
import { useSelector } from 'react-redux';
import { convertDate, simpleEncrypt, getToaster, customToString } from '../../utils/helpers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { useHistory } from 'react-router-dom';
import { faCopy } from '@fortawesome/free-regular-svg-icons';
import { config } from 'config';
import { store } from 'react-notifications-component';
import { SUCCESS, APP_NAME } from 'utils/constants/notifyTypes';

export const EventStudentTables = () => {
    const history = useHistory();

    const { eventSingleShowState } = useSelector((state: storeTypes.IStore) => state);
    const { data, isLoading } = eventSingleShowState;
    const studentRegister = data?.register_students || [];

    const copyLink = async (eventId: number, studentId: number) => {
        console.log('Copy Link');
        const base64EventId = btoa(customToString(eventId));
        const base64StudentId = btoa(customToString(studentId));
        const copyURL = `${config.apiBaseURL}/download_certificate/${base64EventId}/${base64StudentId}`;
        await navigator.clipboard.writeText(copyURL);
        store.addNotification(getToaster(`${APP_NAME} Link copied to clipboard`, '  ', SUCCESS));
    };

    // eslint-disable-next-line no-shadow
    const TableRow = ({ data, index }: { data: eventSingleShowReducerTypes.IRegisterStudents; index: number }) => {
        return (
            <tr>
                <td>
                    <span className="fw-normal">{index + 1}</span>
                </td>
                <td>
                    <span className="fw-normal">{data?.register_id}</span>
                </td>
                <td>
                    <span className="fw-normal">{data?.student?.name}</span>
                </td>
                <td>
                    <span className="fw-normal">{data?.student?.mobileNumber}</span>
                </td>
                <td>
                    <span className="fw-normal">{data?.student?.collegeName}</span>
                </td>
                <td>
                    <span className="fw-normal">{data?.student?.department}</span>
                </td>
                <td>
                    <span className="fw-normal">{convertDate(data?.created_at, 'DD-MM-YYYY hh:mm A')}</span>
                </td>
                <td>
                    <Dropdown.Item onClick={() => history.push(`/students/${simpleEncrypt(data?.student_id)}/view`)}>
                        <FontAwesomeIcon icon={faEye} className="me-2" />
                    </Dropdown.Item>
                    <Dropdown.Item
                        title="Copy Download Certificate"
                        onClick={() => copyLink(data?.event_id, data?.student_id)}
                    >
                        <FontAwesomeIcon icon={faCopy} className="me-2" />
                    </Dropdown.Item>
                </td>
            </tr>
        );
    };

    return (
        <Card border="light" className="table-wrapper table-responsive shadow-sm">
            <Card.Body className="pt-0">
                <Table hover className="user-table align-items-center">
                    <thead>
                        <tr>
                            <th className="border-bottom">#</th>
                            <th className="border-bottom">Register ID</th>
                            <th className="border-bottom">Name</th>
                            <th className="border-bottom">Mobile</th>
                            <th className="border-bottom">College</th>
                            <th className="border-bottom">Department</th>
                            <th className="border-bottom">Register Date</th>
                            <th className="border-bottom">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoading && (
                            <tr>
                                <td align="center" colSpan={8}>
                                    <div className="spinner-border" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </td>
                            </tr>
                        )}

                        {!isLoading && !studentRegister.length && (
                            <tr>
                                <td align="center" colSpan={6}>
                                    <span className="fw-normal">Not yet registered</span>
                                </td>
                            </tr>
                        )}

                        {!isLoading &&
                            studentRegister.map(
                                (studentData: eventSingleShowReducerTypes.IRegisterStudents, index: number) => {
                                    return (
                                        <TableRow
                                            data={studentData}
                                            index={index}
                                            key={`transaction-${studentData.id}`}
                                        />
                                    );
                                }
                            )}
                    </tbody>
                </Table>
            </Card.Body>
        </Card>
    );
};
